// eslint-disable-next-line import/prefer-default-export
export const LOAD_SEGMENTS = 'LOAD_SEGMENTS';
export const SET_SEGMENTS_FILTER = 'SET_SEGMENTS_FILTER';
export const SET_SEGMENT_PAGINATION = 'SET_SEGMENT_PAGINATION';
export const SET_SEGMENT_SORT = 'SET_SEGMENT_SORT';
export const LOAD_EDITABLE_SEGMENT = 'LOAD_EDITABLE_SEGMENT';
export const SET_EMPTY_EDITABLE_SEGMENT = 'SET_EMPTY_EDITABLE_SEGMENT';
export const RESET_FILTER_SEGMENTS = 'RESET_FILTER_SEGMENTS';
export const ADD_NEW_SEGMENT = 'ADD_NEW_SEGMENT';
export const EDIT_SEGMENT = 'EDIT_SEGMENT';
export const TOGGLE_SEGMENT_STATUS = 'TOGGLE_SEGMENT_STATUS';
export const LOAD_SUB_SEGMENTS = 'LOAD_SUB_SEGMENTS';
